import { apiClient } from '..'

const getDepartments = async (companySlug: string) => {
    return await apiClient().get(`/api/company/departments?companySlug=${companySlug}`)
}

export { getDepartments }
